<template>
	<div id="api-keys" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar mode="settings"></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head class="mb-3" title="API Keys" subtitle="Password Security Portal"></dash-head>		

				<table-actions placeholder="search results" hideSearch="true" hideEdit="true"  @delete-click="deleteClicked"
					 :deleteEnabled="checkedRows.length > 0">
				</table-actions>

				<error :error="error"></error>

				<table-view id="apikey-results">
					<table-row slot="header">
						<table-header></table-header>
        				<table-header class="headerSortDown2">API Key</table-header>
        				<table-header>Site</table-header>
						<table-header>Licence Key</table-header>
					</table-row>
					<table-row slot="body" v-for="result in results" :key="result.rowKey">
						<table-cell><input type="checkbox" class="select-row" :value="result.rowKey" v-model="checkedRows"></table-cell>
						<table-cell>{{result.rowKey}}</table-cell>
						<table-cell>{{result.site}}</table-cell>
						<table-cell>{{result.licenceKey}}</table-cell>
					</table-row>
				</table-view>

				<div class="row">
					<div class="col-md-6">
						<table-pagination ref="tablePagination" :page="1" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
					</div>					
				</div>

			</div>
		</div>	
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import TablePagination from './TablePagination'
	import Error from './Error'

	import api from '../api'
	import router from '../router'
	import store from '../state'

	export default {
		name: 'APIKeysPanel',
		props: ['pageSize'],
		components: {SideBar, DashHead, TableActions, TableView, TableRow, TableHeader, TableCell, TablePagination, Error},
		data() {
			return {
				totalRows: 0,
				results: null,
				loadingData: false,
				data: null,
				error: null,
				resultFound: null,
				checkedRows: []
			}
		},
		methods: {
			async deleteClicked(value)
			{						
				try
				{
					for (let row of this.checkedRows) {
						await api.delete(`system/apikeys/${this.site}/${row}`);	
						
						//Loop through this.data and remove entry with rowKey = row
						this.data.splice(this.data.findIndex(item => item.rowKey === row), 1);
					}
					this.checkedRows = [];
					this.pageChanged(1);
				}
				catch(err) {					
					this.error = err;
				}
			},
			pageChanged(value) {
				const start = (value-1) * this.pageSize;		
				
				this.results = [];								

				for (var result of this.data.slice(start, start + this.pageSize)) {				
					this.results.push(result);
				}							
			}
		},
		async mounted() {
			try
			{
				const response = await api.get(`system/apikeys/${this.site}`);					
				this.data = response.data;

				this.data.sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp));

				this.totalRows = response.data.length;
				this.pageChanged(1);
			}
			catch(err) {
				this.error = err;
			}
		},
		computed: {
			site() {
				return store.state.user.site;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/APIKeysPanel.vue